import { createFileRoute } from "@tanstack/react-router";

import { AdminUserManagement } from "@/components/admin/admin-user-management";

export const Route = createFileRoute("/admin/users")({
	component: RouteComponent,
});

function RouteComponent() {
	return <AdminUserManagement />;
}
